import React from 'react';
import { FadeIn } from '../FadeIn';

const OperatorsLens = () => {
  return (
    <section className="relative py-32 md:py-48 bg-c-dark text-c-cream noise-overlay">
      <div aria-hidden="true" className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[60%] h-[250px] bg-gradient-to-t from-c-mauve/8 to-transparent pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center py-12 md:py-20">
        <FadeIn>
          <h2 className="text-xs font-medium tracking-super-wide uppercase text-c-powder/50 mb-12">The Operator's Lens</h2>
        </FadeIn>

        <FadeIn delay={0.1}>
          <h3 className="text-3xl md:text-5xl lg:text-6xl font-light text-white leading-[1.15] mb-10">
            Brands aren't built in boardrooms.<br />
            They're built in the <span className="font-serif-italic text-gradient">trenches.</span>
          </h3>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p className="text-xl md:text-2xl text-c-powder/60 font-light leading-relaxed max-w-2xl mx-auto mb-14">
            Every recommendation we make has been tested in the field — by teams who ship, founders who sell, and operators who know that clarity isn't a luxury. It's the difference between scaling and stalling.
          </p>
        </FadeIn>

        <FadeIn delay={0.3}>
          <button
            onClick={() => { const el = document.getElementById('contact'); if (el) { const offset = window.innerWidth < 768 ? 64 : 80; window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' }); } }}
            className="inline-flex items-center gap-3 text-xs font-medium tracking-widest uppercase px-10 py-4 rounded-xl cta-wire"
          >
            Start a Conversation
          </button>
        </FadeIn>
      </div>
    </section>
  );
};

export default OperatorsLens;
